import { Form, Select } from 'antd';
import { FormattedMessage } from 'react-intl';

const ResultOrderFilterFormItem: React.FC = () => (
  <Form.Item noStyle name="order">
    <Select
      style={{ width: '100%' }}
      placeholder={<FormattedMessage id="customers.filters.order" />}
    >
      <Select.Option value="ASC">
        <FormattedMessage id="customers.filters.order.options.asc" />
      </Select.Option>
      <Select.Option value="DESC">
        <FormattedMessage id="customers.filters.order.options.desc" />
      </Select.Option>
    </Select>
  </Form.Item>
);

export default ResultOrderFilterFormItem;
